import { Instance } from 'mobx-state-tree';
import model from './model';
import views from './views';

const YsiSensor = model.views(views);

export interface IYsiSensor extends Instance<typeof YsiSensor> {}

export default YsiSensor;
